import styled from "styled-components";
import { FlexMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const Header = styled.div.withConfig({
    displayName: "styled__Header",
    componentId: "sc-c8f1b18a-0"
})`
	${FlexMixin({
    align: 'center',
    justify: 'space-between'
})}
	display: flex;

	& > p {
		margin-right: 15px;
	}

	& > button {
		margin-left: auto;
		white-space: nowrap;
	}
`;

//# sourceMappingURL=styled.js.map